import { useEffect, useState } from "react";
import useThemeLocalService from "../services/theme-local.service";
import { THEME } from "../constants/app.constant";

/**
 * useThemeDetector hook detects and syncs with the system's preferred color scheme.
 * Listens to changes in the user's system theme preference (dark/light mode)
 * and updates local theme storage accordingly.
 * 
 * @hook
 * @returns {boolean} Whether dark theme is currently active
 * 
 * @example
 * ```tsx
 * const isDarkTheme = useThemeDetector();
 * 
 * return (
 *   <div className={isDarkTheme ? 'dark' : 'light'}>
 *     Content
 *   </div>
 * );
 * ```
 */
export const useThemeDetector = () => {
    const { getTheme, setTheme } = useThemeLocalService();
    const localTheme = getTheme();

    const getCurrentTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches;
  // const [isDarkTheme, setIsDarkTheme] = useState(localTheme ? (localTheme === THEME.DARK) : getCurrentTheme());
  const [isDarkTheme, setIsDarkTheme] = useState(false);


    const mqListener = (e: any) => {
        setTheme(e.matches ? THEME.DARK : THEME.LIGHT);
        setIsDarkTheme(e.matches);
    };
    
    useEffect(() => {
      const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
      darkThemeMq.addEventListener('change', mqListener);
      
      return () => darkThemeMq.removeEventListener('change', mqListener);
    }, []);
    
    return isDarkTheme;
}